import {
  QuestionReviewTaskDetailsProvider,
  QuestionReviewTaskDetailsRouteController,
} from '@exam-management/new-question-review-task-details';
import {
  QuestionReviewTaskQuestionDetailsPageHeader,
  QuestionReviewTaskQuestionDetailsProvider,
} from '@exam-management/new-question-review-task-question-details';
import { useParams } from '@exam-management/router';
import { TaskManagementPermissionRoute } from '@exam-management/task-management';
import { Outlet } from 'react-router-dom';

export default function TaskManagementQuestionDetailsLayout() {
  const { taskId, questionId } = useParams(
    '/task-management/question-review/:taskId/question-details/:questionId',
  );

  return (
    <TaskManagementPermissionRoute taskId={taskId}>
      <QuestionReviewTaskDetailsProvider taskId={taskId}>
        <QuestionReviewTaskQuestionDetailsProvider taskId={taskId} questionId={questionId}>
          <QuestionReviewTaskDetailsRouteController>
            <QuestionReviewTaskQuestionDetailsPageHeader />
            <Outlet />
          </QuestionReviewTaskDetailsRouteController>
        </QuestionReviewTaskQuestionDetailsProvider>
      </QuestionReviewTaskDetailsProvider>
    </TaskManagementPermissionRoute>
  );
}
